
import React, { createContext, useContext } from 'react';
import { message } from 'antd';

const MessageContext = createContext<any>(null);

export const useGlobalMessage = () => useContext(MessageContext);

interface AppMessageContextProps {
  children: React.ReactNode;
}

const AppMessageContext: React.FC<AppMessageContextProps> = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();
  return (
    <MessageContext.Provider value={messageApi}>
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};

export default AppMessageContext;